<template>
  <div class="landing-view-container">
    <h1>Hallo du,</h1>
    <p>schön, dass du mit "F-EASY, Führerschein schnell und EASY" lernst!</p>
    <p>
      Zum Testen das Menu über den Burger Button öffnen und "Grundwissen" oder
      "B-Führerschein" auswählen
    </p>
    <div class="logo">
      <img src="@/assets/logo-claim-vert.png" alt="F-EASY LOGO" />
    </div>
    <p>
      Alle wichtigen Erklärungen über die Funktion der APP findest du unter
      <router-link to="hilfe">APP erklärt</router-link><br />
      Starte gleich los und wähle deine Fragenkategorie. Du kannst die Kategorie
      jederzeit im Burgermenü oder über den Homebutton wechseln.
    </p>
    <div class="page-list-container">
      <ul>
        <li>
          <router-link to="/fragen">Alle Fragen:</router-link> Hier kommen alle
          Fragen aus Grundwissen und B-Führerschein gemischt.
        </li>
        <li>
          <router-link to="/grundwissen">Grundwissen:</router-link> Hier findest
          du alle Fragen aus dem Bereich Grundwissen. Du kannst auch nach
          Themengebieten lernen. Die Ziffern, zum Beispiel hinter
          Gefahrenzeichen 0/78 bedeuten, dass du zurzeit Null richtige Fragen
          von insgesamt 78 gelernt hast.
        </li>
        <li>
          <router-link to="/b-fuehrerschein">B-Führerschein:</router-link> Hier
          findest du alle Fragen aus dem Bereich B-Führerschein. Du kannst auch
          nach Themengebieten lernen. Die Ziffern, zum Beispiel hinter
          B-Rechtsvorschriften 0/100 bedeuten, dass du zurzeit Null richtige
          Fragen von insgesamt 100 gelernt hast.
        </li>
        <li>
          <router-link to="/5-punkte-fragen">5-Punkte Fragen:</router-link> Die
          5-Punkte Fragen werden während der Führerscheinprüfung mit der
          höchsten Punktzahl für die richtige Antwort gewertet – mit 5 Punkten.
          Diese Fragen sollte man sehr gut können, deshalb solltest du diese
          Kategorie intensiv lernen.
        </li>
        <li>
          <router-link to="/schwere-fragen">Schwere Fragen:</router-link> Hier
          findest du die 300 am öftesten falsch beantworteten Fragen
          zusammengefasst.
        </li>
        <li>
          <router-link to="/falsch-beantwortete">Falsche Fragen:</router-link>
          Hier werden alle Fragen gespeichert, die du selbst falsch beantwortet
          hast, damit du sie gezielt üben kannst.
        </li>
        <li>
          <router-link to="/frage">Frage suchen nach ID:</router-link> Hier
          kannst du eine Frage mit der ID-Nummer aus deinem Kursbuch suchen.
        </li>
        <li>
          <router-link to="/pruefung">Prüfungssimulator:</router-link> Du
          erhältst einen Fragenmix wie bei der theoretischen
          Führerschein-Prüfung.
        </li>
      </ul>
    </div>
    <p class="success-message">
      Wir wünschen dir viel Erfolg – du schaffst das!
    </p>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "LandingView",
  mounted() {
    this.setPageType("home");
  },
  methods: {
    ...mapActions(["setPageType"]),
  },
};
</script>

<style lang="scss" scoped>
.landing-view-container {
  padding: $default-container-padding;

  h1 {
    font-weight: 300;
    font-size: 1em;
  }

  .logo {
    max-width: 75%;
    margin: 50px auto;
  }

  .page-list-container {
    ul {
      li {
        margin-bottom: 20px;
        list-style-type: none;
        a {
          font-weight: bold;
        }
      }
    }
  }

  .success-message {
    text-align: center;
    font-size: 1.2em;
    margin: 40px 0;
  }
}
</style>
